import { type IAddress } from '@/services';

import Icon from './Icon';

type LocationListProps = {
  locations: IAddress[] | null;
  title?: string;
};

const LocationList = ({ locations, title }: LocationListProps) => {
  const getMapLink = (address: string) => {
    const mapLinkTemplate = 'https://www.google.com/maps/dir/?api=1&destination={address}';
    return mapLinkTemplate.replace('{address}', encodeURIComponent(address));
  };

  return (
    <div className="py-4 md:p-0">
      <h2 className="text-lg font-bold mb-4">{title}</h2>
      <ul className="list-none list-inside">
        {locations?.map((location, index) => (
          <li key={index} className="mb-2 py-1">
            <a
              href={getMapLink(`${location.street_name} ${location.street_number} ${location.apartment ? `, ${location.apartment}` : ''}, ${location.zipcode}`)}
              className="text-theme-link flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <Icon name="map-marker" />
              </div>
              <div>
                {location.street_name} {location.street_number} {location.apartment ? `, ${location.apartment}` : ''}, {location.zipcode}
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LocationList;
